import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';


@Directive({
  selector: '[formControlFilename]',
  exportAs: 'form-control-filename',
})
export class FormControlFilenameDirective {

  @Input() formControl: UntypedFormControl;

  fileType: string;
  private fullValue: string;

  constructor(
    private elementRef: ElementRef
  ) {}

  // handlers
  @HostListener('focus', ['$event.target.value'])
  onFocus(value: any) {
    this.elementRef.nativeElement.value = this.cutFileType(this.formControl.value);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: any) {
    this.fullValue = this.fileType ? `${value}.${this.fileType}` : value;
    this.formControl.setValue(this.fullValue);
  }

  // private
  private cutFileType(value: string): string {
    if (!value || value.indexOf('.') === -1) { return value; }
    const splitted = value.split('.');
    this.fileType = splitted[splitted.length - 1];
    return splitted.slice(0, -1).join('');
  }
}
